'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg12 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 12, height: 13, viewBox: "0 0 12 13", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.55652 11.6861C8.23246 12.063 7.66422 12.1059 7.28733 11.7818L3.37675 8.41954C3.36623 8.41049 3.35561 8.40137 3.34491 8.39218C3.1684 8.24057 2.97124 8.07122 2.82577 7.90544C2.65477 7.71055 2.44853 7.40439 2.44853 6.97885C2.44852 6.55332 2.65476 6.24715 2.82576 6.05226C2.97122 5.88648 3.16839 5.71712 3.3449 5.56551C3.35559 5.55633 3.36621 5.5472 3.37674 5.53815L7.24936 2.20844C7.62626 1.88439 8.19449 1.92722 8.51855 2.30412C8.84261 2.68101 8.79978 3.24925 8.42288 3.57331L4.55026 6.90302C4.51874 6.93012 4.48949 6.95528 4.46219 6.97884C4.48949 7.00241 4.51874 7.02757 4.55026 7.05467L8.46083 10.4169C8.83773 10.741 8.88057 11.3092 8.55652 11.6861ZM4.17136 7.2483C4.17135 7.2483 4.17164 7.24791 4.17227 7.24712L4.17136 7.2483Z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg12;
//# sourceMappingURL=12.js.map
